import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';

export interface SupprimerUtilisateurInput {
  idUtilisateur: string;
}

export class SupprimerUtilisateurUseCase implements IUseCase<SupprimerUtilisateurInput, void> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: SupprimerUtilisateurInput): Promise<void> {
    const response = await this.repository.supprimerUtilisateur(input.idUtilisateur);

    if (!response.succes) {
      throw new Error(response.message || 'Erreur lors de la suppression');
    }
  }
}
